import { gettext } from '@eventbrite/i18n';
import { TicketCard } from '@eventbrite/listings-multitickets';
import { Stack } from '@eventbrite/marmalade';
import React from 'react';
import { useTicketsContext } from '../../contexts/TicketsContext';
import { EventDetailsSectionTitle } from '../EventDetails/EventDetails';
import { TicketClass } from './types';
import { shouldShowTicketsSection } from './utils';

export const Tickets = () => {
    const { ticketClasses, checkoutDisqualifications } = useTicketsContext();

    if (!shouldShowTicketsSection(checkoutDisqualifications)) {
        return null;
    }

    return (
        <section className="event-details__section">
            <EventDetailsSectionTitle>
                <h2>{gettext('Tickets')}</h2>
            </EventDetailsSectionTitle>
            <Stack space="spacing-lg" as="ul">
                {ticketClasses.map((ticket: TicketClass, index: number) => {
                    return (
                        <li key={index}>
                            <TicketCard
                                characteristics={{
                                    defaultQuantity: 1,
                                }}
                                onQuantityChange={() => undefined}
                                description={ticket.description}
                                displayFlags={ticket.displayFlags}
                                id={index.toString()}
                                name={ticket.displayName}
                                price=""
                                quantityRemaining={ticket.quantityRemaining}
                            />
                        </li>
                    );
                })}
            </Stack>
        </section>
    );
};
